import { Routes, Route, Navigate } from 'react-router-dom'
import { AppShell } from './app/AppShell'
import { HomeView } from './features/home/HomeView'
import { PulseView } from './features/pulse/PulseView'
import { ProductsView } from './features/products/ProductsView'
import { ProductDetailView } from './features/products/ProductDetailView'
import { SettingsView } from './features/settings/SettingsView'
import { LocationsView } from './features/locations/LocationsView'
import { StormModeView } from './features/storm/StormModeView'
import { WatchingView } from './features/storm/WatchingView'
// MapRoute is eager + tiny; it code-splits MapScreen (Mapbox GL + Turf + TopoJSON ~650 kB
// gz) inside a Suspense + error boundary so the back-link chrome is always available.
import { MapRoute } from './features/map/MapRoute'

export default function App() {
  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<HomeView />} />
        <Route path="/pulse" element={<PulseView />} />
        <Route path="/products" element={<ProductsView />} />
        <Route path="/products/:productId" element={<ProductDetailView />} />
        <Route path="/settings" element={<SettingsView />} />
        <Route path="/locations" element={<LocationsView />} />
        {/* Standalone weather-MAP — full-screen Mapbox radar (M1: radar core). */}
        <Route path="/map" element={<MapRoute />} />
        {/* Severe-weather escalation: amber WATCHING + red STORM MODE takeover. */}
        <Route path="/watching" element={<WatchingView />} />
        <Route path="/storm" element={<StormModeView />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  )
}
